import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Container } from "@mui/material";
import CoursePlayer from "../../../components/CoursePlayer/CoursePlayer";
import { push } from "connected-react-router";
import {
  fetchCourseCtoa,
  fetchUserAssignmentsList
} from "../../../redux/actions/userAssignmentsListActions";
import {
  buildContentViewerRoute,
  buildCourseOverviewRoute
} from "../../../routes/LearningCenterRoutes";
import { makeGetEntities } from "../../../redux/selectors/selectors";
import {
  assignmentTypes,
  courseSectionTypes,
  courseTypes
} from "../../../constants/index";

const selector = makeGetEntities();

const getActivityLink = (userAssignmentId, id) =>
  buildContentViewerRoute(userAssignmentId, id);

class CoursePlayerWrapper extends React.Component {
  componentDidMount() {
    this.props.fetchCourseCtoa(this.props.match.params.id);
    this.props.fetchUserAssignmentsList("");
  }

  handleGoToActivityClick = courseContentable => {
    const {
      assignedTrainingObjectId,
      enrolledTrainingObjectId
    } = this.props.courseData;

    const overviewPath =
      !!assignedTrainingObjectId && !!enrolledTrainingObjectId
        ? buildCourseOverviewRoute(
            assignedTrainingObjectId,
            enrolledTrainingObjectId
          )
        : "";

    const isOverview = courseContentable.isOverview;
    const activityLink = isOverview
      ? overviewPath
      : getActivityLink(
          courseContentable.userAssignmentId,
          courseContentable.id
        );

    this.props.push(activityLink);
  };

  renderCoursePlayer() {
    const { courseData, courseTitle, isLoading, userAssignment } = this.props;
    const mandatorySections = courseData?.courseSections.filter(
      ({ sectionType }) => sectionType === courseSectionTypes.mandatory
    );
    const optionalSections = courseData?.courseSections.filter(
      ({ sectionType }) => sectionType === courseSectionTypes.optional
    );
    return (
      <CoursePlayer
        {...courseData}
        modules={mandatorySections}
        resources={optionalSections}
        courseTitle={courseTitle}
        isLoading={isLoading && !courseData}
        onGoToActivityClick={this.handleGoToActivityClick}
        isSelfAssignedPolicy={
          userAssignment?.courseType === courseTypes.policy &&
          userAssignment?.assignmentType === assignmentTypes.self
        }
      />
    );
  }

  render() {
    return <Container maxWidth="xl">{this.renderCoursePlayer()}</Container>;
  }
}

const mapStateToProps = ({ userAssignmentsListState, loadingState }, props) => {
  const courseId = props.match.params.id;

  const ctoas = selector(userAssignmentsListState, {
    type: "customerTrainingObjectAssignment"
  });
  const userAssignments = selector(userAssignmentsListState, {
    type: "userAssignment"
  });
  const userAssignment = !!userAssignments
    ? userAssignments.find(
        assignment => `${assignment.assignedTrainingObjectId}` === courseId
      )
    : {};

  // make sure we get all ctoas that fit this course Id and grab the latest version.

  const courseData = ctoas
    ?.filter(assignment => `${assignment.assignmentId}` === userAssignment?.id)
    .pop();

  let courseTitle = courseData?.title;

  // Grabs the course title from the user assignments if they've been loaded already
  if (!courseTitle && !!userAssignments) {
    const assignedTrainingObject = userAssignments.find(
      assignment => `${assignment.assignedTrainingObjectId}` === courseId
    );
    if (
      assignedTrainingObject &&
      assignedTrainingObject.enrolledTrainingObject
    ) {
      courseTitle = assignedTrainingObject.enrolledTrainingObject.name;
    } else if (assignedTrainingObject && assignedTrainingObject.versions) {
      courseTitle = assignedTrainingObject.versions.find(
        version =>
          version.id === assignedTrainingObject.enrolledTrainingObjectId
      )?.name;
    }
  }
  return {
    courseData,
    userAssignment,
    courseTitle,
    isLoading: loadingState[("FETCH_COURSE_CTOA", "FETCH_USER_ASSIGNMENT_LIST")]
  };
};

export default connect(mapStateToProps, {
  fetchCourseCtoa,
  fetchUserAssignmentsList,
  push
})(CoursePlayerWrapper);

CoursePlayerWrapper.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  })
};
